"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "@posthog/react";
import { useEffect } from "react";
import { getRuntimeConfig } from "@/lib/runtime-config";
import { installRequestProgress } from "@/lib/request-progress";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    installRequestProgress();
  }, []);

  useEffect(() => {
    let cancelled = false;

    getRuntimeConfig()
      .then(({ posthogHost, posthogKey }) => {
        if (cancelled) return;

        posthog.init(posthogKey, {
          api_host: posthogHost,
          defaults: "2025-05-24",
        });
      })
      .catch((error) => {
        console.error("Failed to initialize PostHog", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
